import { bool, number, shape, string } from 'prop-types';

export const reviewEntity = shape({
  entityType: string,
  id: string,
  label: string,
  url: string,
});

export const ratingScore = shape({
  activity: number,
  careService: number,
  cleanliness: number,
  mealDining: number,
  staff: number,
  value: number,
});

export const reviewInfo = shape({
  email: string,
  firstName: string,
  lastName: string,
  isCriticReview: bool,
  isVerified: bool,
  ratingScore,
  relation: string,
});

export const statusByUser = shape({
  admin: bool,
  confirmedAt: string,
  createdAt: string,
  email: string,
  hasPasswordSet: bool,
  id: string,
  name: string,
  phoneNumber: string,
  roleID: number,
  updatedAt: string,
  uuid: string,
});

export const reviewPagination = shape({
  approvedCount: number,
  current: number,
  filteredCount: number,
  pendingCount: number,
  rejectedCount: number,
  show: bool,
  size: number,
  text: string,
  total: number,
  totalCount: number,
});

const review = shape({
  comments: string,
  createdAt: string,
  entity: reviewEntity,
  id: string,
  info: reviewInfo,
  rateableSlug: string,
  rateableType: string,
  ratingBy: number,
  ratingByType: string,
  status: number,
  statusByUser,
  statusDate: string,
  updatedAt: string,
  value: number,
});

export default review;
